import { render, staticRenderFns } from "./GroupParamElement.vue?vue&type=template&id=2b765ffe&scoped=true&"
import script from "./GroupParamElement.vue?vue&type=script&lang=js&"
export * from "./GroupParamElement.vue?vue&type=script&lang=js&"
import style0 from "./GroupParamElement.vue?vue&type=style&index=0&id=2b765ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b765ffe",
  null
  
)

export default component.exports